<button
  [type]="type"
  [disabled]="disabled || loading"
  [ngClass]="computedClasses"
  [attr.aria-label]="ariaLabel || null"
  [attr.aria-expanded]="ariaExpanded"
  [attr.aria-pressed]="ariaPressed"
  [attr.title]="buttonTitle || null"
  (click)="onClick($event)"
>
  @if (loading) {
    <span class="mr-2 flex items-center">
      <svg class="animate-spin h-4 w-4" viewBox="0 0 24 24">
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="3"
          fill="none"
          opacity="0.3"
        ></circle>
        <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="3" fill="none"></path>
      </svg>
    </span>
  }

  @if (!loading && hasIcon && icon && iconPosition === 'left') {
    <span [ngClass]="iconContainerClasses">
      <app-icon-reusable
        [icon]="icon"
        [size]="iconSize"
        [useCurrentColor]="iconUseCurrentColor"
        [classes]="iconClasses"
      ></app-icon-reusable>
    </span>
  }

  <span [ngClass]="projectedContentClasses">
    <ng-content></ng-content>
  </span>

  @if (!loading && hasIcon && icon && iconPosition === 'right') {
    <span [ngClass]="iconContainerClasses">
      <app-icon-reusable
        [icon]="icon"
        [size]="iconSize"
        [useCurrentColor]="iconUseCurrentColor"
        [classes]="iconClasses"
      ></app-icon-reusable>
    </span>
  }
</button>
